import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { ContactsOutlined, InfoCircleOutlined, LogoutOutlined } from '@ant-design/icons'
import { Avatar, Button, Divider, Modal, Popover } from 'antd'
import moment from 'moment'

import { history } from '../../appRedux/store'
import FormHeader from '../../components/FormHeader/FormHeader'
import { api, request } from '../../util/handlerRequestUtil'
import versionDetails from '../../util/version'

moment.updateLocale(moment.locale('pt-br'), { invalidDate: '-' })

const UserInfo = () => {
  const [isPopOverVisible, setIsPopOverVisible] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false)
  //const [versionApi, setVersionApi] = useState('')
  const [versionApiEib, setVersionApiEib] = useState('')
  const [supportContacts, setSupportContacts] = useState('')

  const auth = useSelector((state) => state.auth.auth)

  useEffect(() => {
    getSupportContacts()
  }, [])

  async function getSupportContacts() {
    try {
      //const [response] = await request(api.version())
      const responseEib = await request(api.versionEib())
      const supportContacts = await request(api.supportContacts())
      //setVersionApi(response)
      setVersionApiEib(responseEib)
      setSupportContacts(supportContacts)
    } catch (error) {
      console.error(error)
    }
  }

  let userFirstLetter = ''
  if (auth.userLogin && auth.userLogin.length > 0) {
    userFirstLetter = auth.userLogin[0]
  }

  function handlerProfileName(currentRoles) {
    let formattedProfile = ''

    if (currentRoles.length > 0) {
      if (currentRoles.length === 1) {
        formattedProfile = currentRoles.name + ' /'
      } else {
        currentRoles.forEach((element) => (formattedProfile += element.name + ' / '))
      }
    } else {
      formattedProfile = 'Sem perfil definido '
    }

    return formattedProfile.slice(0, -1)
  }

  async function help() {
    const data = await request(api.findParametersByKey('sharepoint-bayer'))
    window.open(data.parameterValue.url)
  }

  function logout() {
    window.localStorage.clear()
    history.replace('/login')
    window.location.href = '/login'
  }

  const userMenuOptions = (
    <div>
      <div style={{ textAlign: 'center', marginBottom: '15px' }}>
        <Avatar style={{ background: '#263447', height: '64px', width: '64px', marginBottom: 5 }}>
          <span
            style={{
              fontSize: '32px',
              textTransform: 'uppercase',
              position: 'relative',
              top: '15px'
            }}
          >
            {userFirstLetter}
          </span>
        </Avatar>
        <h3>{auth.name}</h3>
        <h5>{auth.userLogin}</h5>
      </div>
      <Divider />
      <ul className="gx-user-popover" style={{ margin: '10px' }}>
        <li
          onClick={() => {
            setIsPopOverVisible(false)
            setIsModalVisible(true)
          }}
          style={{ width: '100%', height: '36px' }}
        >
          <div style={{ marginTop: '7px', paddingLeft: '20px' }}>
            <ContactsOutlined style={{ paddingRight: '10px' }} />
            Informações de Suporte
          </div>
        </li>

        <li onClick={help} style={{ width: '100%', height: '36px' }}>
          <div style={{ marginTop: '7px', paddingLeft: '20px' }}>
            <InfoCircleOutlined style={{ paddingRight: '10px' }} />
            Ajuda
          </div>
        </li>

        <li onClick={logout} style={{ width: '100%', height: '36px' }}>
          <div style={{ marginTop: '7px', paddingLeft: '20px' }}>
            <LogoutOutlined style={{ paddingRight: '10px' }} />
            Sair
          </div>
        </li>
      </ul>
    </div>
  )

  return (
    <>
      <Popover
        overlayClassName="gx-popover-horizantal"
        placement="bottomRight"
        content={userMenuOptions}
        onClick={() => setIsPopOverVisible(!isPopOverVisible)}
        trigger="click"
        visible={isPopOverVisible}
      >
        <Avatar
          style={{ background: '#263447', height: '34px', width: '34px', marginBottom: 4 }}
          className="gx-avatar gx-pointer"
          alt=""
        >
          <span
            style={{
              fontSize: '22px',
              textTransform: 'uppercase',
              position: 'relative',
              top: '3px'
            }}
          >
            {userFirstLetter}
          </span>
        </Avatar>
      </Popover>
      <Modal
        title="Informações de Suporte"
        footer={null}
        onCancel={() => setIsModalVisible(false)}
        width="70%"
        visible={isModalVisible}
      >
        <div>
          <div style={{ marginLeft: -10 }}>
            <FormHeader fontSize="11px" title="Usuário" orientation="left" type="horizontal" />
          </div>
          <div>
            <b>Nome:</b> {auth.name}
          </div>
          <div>
            <b>Perfil:</b>{' '}
            {auth.name !== 'SYSADMIN'
              ? handlerProfileName(auth.hierarchies.length && auth.hierarchies[0].currentRoles)
              : 'Sem perfil definido'}
          </div>
          <div>
            <b>Data/Hora:</b> {moment().format('ddd MMM DD YYYY kk:mm:ss Z')}
          </div>
        </div>

        <div>
          <div style={{ marginLeft: -10 }}>
            <FormHeader fontSize="11px" title="Versão" orientation="left" type="horizontal" />
          </div>
          <div>
            <b>Front-End:</b> {versionDetails.number}
          </div>
          <div>
            <b>Back-End:</b> {versionApiEib}
          </div>
        </div>

        <div>
          <div style={{ marginLeft: -10 }}>
            <FormHeader fontSize="11px" title="Contato" orientation="left" type="horizontal" />
          </div>
          <div>
            <b>Telefone:</b> {supportContacts.phone}
          </div>
          <div>
            <b>E-mail:</b> {supportContacts.mail}
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'end', paddingTop: '20px' }}>
          <Button
            icon="close"
            style={{
              borderColor: '#EE778F',
              color: '#EE778F'
            }}
            type="ghost"
            onClick={() => setIsModalVisible(false)}
          >
            Fechar
          </Button>
        </div>
      </Modal>
    </>
  )
}

export default UserInfo
